// Imports
import React, { useEffect, useState } from 'react';
import LoadingRow from '../../../../../../shareables/foundation/front-end/components/tables/loading-row';
import { useAppDispatch } from '../../../../../../shareables/foundation/front-end/redux/hooks';
import apiActions from '../../../../../../shareables/integrations/api/redux/actions';
import { GetPaymentsResponse } from '../../../../../../shareables/types/api/main/website/payments/get';
import Table from '../../page-types/shared-components/table';
import EmptyStateRow from '../../page-types/shared-components/table/empty-state-row';
import PageTitle from '../../shared-components/page-title';
import PaymentHistoryRow from './row';


// Define the accepted props
interface Props {
	storybookPayments?: GetPaymentsResponse;
}


// Function component
const PaymentHistory: React.FC<Props> = ({ storybookPayments }) => {
	// Use state
	const [payments, setPayments] = useState<GetPaymentsResponse | null>(storybookPayments ?? null);
	
	
	// Use Redux functionality
	const dispatch = useAppDispatch();
	
	
	// Load payments on mount
	useEffect(() => {
		// Call API
		void dispatch(
			apiActions.call<undefined, undefined, GetPaymentsResponse>({
				action: 'GET',
				uri: `/website/${window.location.hostname}/payments`,
				completion: (json) => {
					setPayments(json.response);
				},
			})
		);
	}, [dispatch]);
	
	
	// Return JSX
	return (
		<React.Fragment>
			<PageTitle>Online payment history</PageTitle>
			
			<Table>
				<thead>
					<tr>
						<th>Paid</th>
						<th>Member</th>
						<th>Payment option</th>
						<th style={{ textAlign: 'center' }}>Amount</th>
						<th style={{ textAlign: 'center' }}>Receipt</th>
					</tr>
				</thead>
				<tbody>
					{payments?.map((payment, paymentIndex) => <PaymentHistoryRow payment={payment} key={paymentIndex} />)}
					
					{payments?.length === 0 && <EmptyStateRow>You have not made any online payments yet…</EmptyStateRow>}
					
					{!payments && <LoadingRow />}
				</tbody>
			</Table>
		</React.Fragment>
	);
};

export default PaymentHistory;
